import { render, staticRenderFns } from "./standardSettingsDialog.vue?vue&type=template&id=4514618c&scoped=true"
import script from "./standardSettingsDialog.vue?vue&type=script&lang=js"
export * from "./standardSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./standardSettingsDialog.vue?vue&type=style&index=0&id=4514618c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514618c",
  null
  
)

export default component.exports